import { Button, Col, Row } from "antd";
import ProjectsTable from "../components/ProjectsTable";
import { useNavigate } from "react-router-dom";
import { CgFileAdd } from "react-icons/cg";
import Affectation_formulaire from "../components/Affecter_projet/Affectation_formulaire";
import Disponibilite_projet from "../components/Affecter_projet/Disponibilite_projet";
import Title from "antd/es/typography/Title";
import { useEffect, useState } from "react";
import { TrancheInterface } from "../domaine/projectModel";

interface DataType {
  id: number;
  nom_du_projet: string;
  titre_foncier: string;
  numero_de_permis_de_construire: string;
  surface_fonciere: number;
  surface_construite: number;
  surface_vendable: number;
  promoteur: null | string;
  type_realisation: string;
  nbr_tranches: number;
  is_big_project: boolean;
  etat_projet: string;
  created_at: string;
  updated_at: string;
  tranches: TrancheInterface[];
}

function ProjectsListPage() {
  const navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<DataType[]>([]);

  useEffect(() => {
    localStorage.setItem("lastPage", window.location.pathname);
  }, []);
  

  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <Title level={5} style={{ width: "100%", padding: "10px",marginBottom: '0px',paddingBottom: '0px' }}>
        Liste des projets
      </Title>
      <Row style={{ width: "100%", padding: "10px",paddingTop: '0px' }} justify={"end"}>
        <Button
          icon={<CgFileAdd />}
          type="primary"
          onClick={() => {
            navigate("/ajouterProjet");
          }}
        >
          Créer un projet
        </Button>
      </Row>

      <ProjectsTable
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        setSelectedRows={setSelectedRows}
      />

      <Row
        gutter={16}
        style={{ width: "100%", padding: "20px", marginTop: "50px" }}
      >
        <Col xs={24} sm={24} md={12} lg={12}>
          <Title level={5}>Disponibilité des visiteurs</Title>
          <Disponibilite_projet />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Title level={5}>Affecter un projet</Title>
          <Affectation_formulaire setSelectedRowKeys={setSelectedRowKeys} />
        </Col>
      </Row>
    </div>
  );
}

export default ProjectsListPage;
